import { IconPaths } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from '../../../../../../components'
import { UnidadeModal } from '../modal/UnidadeModal'

export const UnidadesListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () => showModal({ title: 'Criar Unidade/Setor', content: <UnidadeModal /> })

  return (
    <Button onClick={openModal} icon={IconPaths.Add} className='btn-primary'>
      {t('common.add')}
    </Button>
  )
}
